
import { connect } from 'react-redux';

import VideoPlaylist from './video_playlist.jsx';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import {
  getCurrentSubpage,
  getAssetForContent,
  getSectionAllowAutoplayContentUuid,
  getOrderedAndSelectedNonEmptyContentItemsForSection,
  getSectionBackgroundData
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getBackgroundStyle
} from 'zoomforth_codesbane_viewer/lib/section_backgrounds.js';

import {
  selectSectionContent,
  selectNextContentInVideoPlaylistSection,
  syncToUrlSubpageAndContent
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import {
  getHeightStyle
} from 'zoomforth_codesbane_viewer/lib/sections.js';


const mapStateToProps = (state, { section }) => {

  const [contentItems, selectedContentItem] = getOrderedAndSelectedNonEmptyContentItemsForSection(state, section);

  const autoplay = selectedContentItem ?
      getSectionAllowAutoplayContentUuid(state, section.id) === selectedContentItem.uuid
    :
      false;

  const height = getHeightStyle(section);

  const sectionBackgroundData = getSectionBackgroundData(state, section);
  const backgroundStyle = getBackgroundStyle(sectionBackgroundData);
  const currentSubpage = getCurrentSubpage(state);

  // unorthodox to return a function in mapStateToProps but it allows us to
  // properly build the hidden tab panes
  const getAsset = (contentItem)=> getAssetForContent(state, contentItem);

  return {
    height,
    getAsset,
    backgroundStyle,
    contentItems,
    selectedContentItem,
    // the playlist in the viewer context should autoplay whenever a video has been selected
    // by a user action; getIsSectionNowAutoplayable will tell us that
    autoplay,
    subpageId: currentSubpage.id
  };
};


const mapDispatchToProps = (dispatch, { section }) => (
  {
    onSelectContentClick: (contentItem)=> {
      dispatch(syncToUrlSubpageAndContent(section.id));
      getTracker().handleVideoPlaylistItemSelectHuman(contentItem);
      dispatch(selectSectionContent(section, contentItem, /* autoplay= */true));
    },
    onSelectVideoClick: (contentItem)=> {
      getTracker().handleVideoPlaylistItemSelectHuman(contentItem);
    },
    onEnded: (contentItem, eventData)=> {
      getTracker().handleVideoPlaylistItemEnded(contentItem, eventData);
      dispatch(selectNextContentInVideoPlaylistSection(section, /* autoplay= */true));
    },
    onError: (contentItem, eventData)=> {
      getTracker().handleVideoPlaylistItemError(contentItem, eventData);
    },
    onPause: (contentItem, eventData)=> {
      getTracker().handleVideoPlaylistItemPause(contentItem, eventData);
    },
    onPlay: (contentItem, eventData)=> {
      dispatch(syncToUrlSubpageAndContent(section.id));
      getTracker().handleVideoPlaylistItemPlay(contentItem, eventData);
    },
    onSeeked: (contentItem, eventData)=> {
      getTracker().handleVideoPlaylistItemSeeked(contentItem, eventData);
    },
    onStart: (contentItem, eventData)=> {
      getTracker().handleVideoPlaylistItemStart(contentItem, eventData);
    },
    onTimeUpdate: (contentItem, eventData)=> {
      getTracker().handleVideoPlaylistItemTimeUpdate(contentItem, eventData);
    }
  }
);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoPlaylist);
